export class NewsHighlightData {
  title: string;
  subtitle: string;
  description: string;
  image: string;
  slug: string;
  menu: Array<{ title: string; url?: string }>;
  buttons: Array<{ title: string; url: string; color: string; modal: string }>;
  blocks: {
    bigger: {
      date: string;
      category: string;
      url: string;
      image: string;
      description: string;
      name: string;
      id: string;
    };
    firstSmall: {
      date: string;
      category: string;
      url: string;
      image: string;
      description: string;
      name: string;
      id: string;
    };
    secoundSmall: {
      date: string;
      category: string;
      url: string;
      image: string;
      description: string;
      name: string;
      id: string;
    };
  };

  constructor(params?: NewsHighlightData) {
    this.title = params?.title ? params?.title : 'Notícias';
    this.subtitle = params?.subtitle ? params?.subtitle : '';
    this.description = params?.description ? params?.description : '';
    this.image = params?.image ? params?.image : '';
    this.slug = params?.slug ? params?.slug : '';
    this.menu = params?.menu ? params?.menu : [];
    this.buttons = params?.buttons
      ? params?.buttons
      : [
          {
            title: 'Ler mais',
            url: '',
            color: 'Fundo Primário',
            modal: null,
          },
        ];
    this.blocks = params?.blocks
      ? params?.blocks
      : {
          bigger: null,
          firstSmall: null,
          secoundSmall: null,
        };
  }
}

export interface NewsConfigsData {
  banner: string;
  blocks: {
    bigger: string;
    firstSmall: string;
    secoundSmall: string;
  };
}

export class HighlightBlock {
  url: string;
  image: string;
  category: string;
  name: string;
  description: string;
  constructor(params) {
    this.url = './' + params.slug;
    this.image = params.imagemDestaque[0] ? params.imagemDestaque[0].url : '';
    this.category = params.categoria;
    this.name = params.titulo;
    this.description = params.subtitulo;
  }
}
